// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html body, html body .app.error, html body .app.error .app-body, html body .app.error .app-body > .main, html body .app.error .app-body > .main .container {
  background-color: white !important;
  transition: none;
}

html.dark body, html.dark body .app.error, html.dark body .app.error .app-body, html.dark body .app.error .app-body > .main, html.dark body .app.error .app-body > .main .container {
  background-color: var(--black0) !important;
  transition: none;
}

.error-page {
  position: relative;
  max-width: 570px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: "Inter", sans-serif;
}
@media (max-width: 768px) {
  .error-page {
    padding: 0 1rem;
  }
}
.error-page-icon {
  margin-bottom: 2rem;
}
.error-page-title {
  color: var(--black9);
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  margin-bottom: 1rem;
}
.error-page-info {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-bottom: 2rem;
  color: var(--black5);
}

.error-container {
  display: flex;
  margin: 0;
  justify-content: center;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./client/components/error/style.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,gBAAA;AACF;;AACA;EACE,0CAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gCAAA;AAEF;AAAE;EAVF;IAWI,eAAA;EAGF;AACF;AADE;EACE,mBAAA;AAGJ;AAAE;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;AACE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AACJ;;AAGA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;AAAF","sourcesContent":["html body, html body .app.error, html body .app.error .app-body, html body .app.error .app-body > .main , html body .app.error .app-body > .main .container {\n  background-color: white !important;\n  transition: none;\n}\nhtml.dark body, html.dark body .app.error, html.dark body .app.error .app-body, html.dark body .app.error .app-body > .main, html.dark body .app.error .app-body > .main .container {\n  background-color: var(--black0) !important;\n  transition: none;\n}\n\n.error-page {\n  position: relative;\n  max-width: 570px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  font-family: \"Inter\", sans-serif;\n\n  @media (max-width: 768px) {\n    padding: 0 1rem;\n  }\n\n  &-icon {\n    margin-bottom: 2rem;\n  }\n\n  &-title {\n    color: var(--black9);\n    text-align: center;\n    font-size: 40px;\n    font-weight: 600;\n    line-height: 48px;\n    margin-bottom: 1rem;\n  }\n\n  &-info {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: center;\n    margin-bottom: 2rem;\n    color: var(--black5);\n  }\n}\n\n.error-container {\n  display: flex;\n  margin: 0;\n  justify-content: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
